import { useTranslationWithNamespace } from '@gov-nx/core/service';
import type { PageCode } from '@gov-nx/module/page';
import { useRegistrRidicuContext } from '@gov-nx/module/page';
import { ContentLayout, ErrorStatusBanner, InfoBanner } from '@gov-nx/ui/web';
import { DriversRegistryCompetencyView } from './DriversRegistryCompetencyView';
import { DriversRegistryNavigation } from './DriversRegistryNavigation';
import { DriversRegistryOffencesView } from './DriversRegistryOffencesView';
import { DriversRegistryProhibitionsView } from './DriversRegistryProhibitionsView';
import { DriversRegistrySkeleton } from './DriversRegistrySkeleton';

type DriversRegistryViewProps = {
	code: PageCode;
};

export const DriversRegistryView = ({ code }: DriversRegistryViewProps) => {
	const { data, selectedPage, controls } = useRegistrRidicuContext();
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const ts = getLocalizeCurried(code);

	if (controls.initialLoading) {
		return <DriversRegistrySkeleton />;
	}

	if (controls.initialError) {
		return <ErrorStatusBanner code={code} />;
	}

	if (!data?.hasLicense) {
		return (
			<ContentLayout>
				<InfoBanner
					headline={ts('stav.chyba.zadny-ridicak')}
					text={ts('stav.chyba.zadny-ridicak-popis')}
				/>
			</ContentLayout>
		);
	}

	return (
		<ContentLayout>
			<DriversRegistryNavigation code={code} />
			{selectedPage === 'competency' && (
				<DriversRegistryCompetencyView code={code} />
			)}
			{selectedPage === 'offences' && (
				<DriversRegistryOffencesView code={code} />
			)}
			{selectedPage === 'prohibitions' && (
				<DriversRegistryProhibitionsView code={code} />
			)}
		</ContentLayout>
	);
};

DriversRegistryView.displayName = 'DriversRegistryView';
